import api from './client';

export const fetchOrderDetail = (orderId: string) =>
  api.get(`/orders/${orderId}`).then(res => res.data);
